<template>
  <div class="chuKuZuoyeWarp">
    <div class="searchBox" ref="searchBox">
      <!-- 查询条件 -->
      <div>
        <el-form :inline="true" :model="searchFrom" class="demo-form-inline" size="mini" label-width="100px">
          <el-form-item label="登记时间:">
            <el-date-picker
              v-model="createTimes"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="到访时间:">
            <el-date-picker
              v-model="visitTimes"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="状态:">
            <el-select v-model="searchFrom.auditStatus" placeholder="请选择状态">
              <el-option v-for="item in auditStatusList" :label="item.showName" :key="item.value"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="登记类型:">
            <el-select v-model="searchFrom.applyType" placeholder="请选择货物类型">
              <el-option v-for="item in applyTypeList" :label="item.showName" :value="item.value" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌号:">
            <el-input v-model.trim="searchFrom.vhcNo" placeholder="请输入车牌号"></el-input>
          </el-form-item>
          <el-form-item label="手机号:">
            <el-input v-model.trim="searchFrom.mobile" maxlength="11" v-number-input.float="0" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <div class="searchBtnBox">
            <el-form-item>
              <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
              <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
              <el-button type="primary" size="mini" @click="passFn" v-if="btnFlg[0]">审核通过</el-button>
              <el-button type="primary" size="mini" @click="backFn" v-if="btnFlg[1]">审核驳回</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <!--表格1-->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="tableList" class="elTab" highlight-current-row @row-click="dianjixuanzhong" border height="100%" size="mini" style="width:100%"
      :header-cell-style="{background:'#F5F5F5',color:'black'}"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column prop="applyNo" label="预约号" width="230"></el-table-column>
        <el-table-column prop="" label="登记类型" width="90">
          <template scope="scope">
            <span v-show="scope.row.applyType == '1'">人员登记</span>
            <span v-show="scope.row.applyType == '2'">人车登记</span>
          </template>
        </el-table-column>
        <el-table-column prop="vhcNo" label="车牌号" width="120" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="applyUname" label="到访人" width="120"></el-table-column>
        <el-table-column prop="mobile" label="联系方式" width="120"></el-table-column>
        <el-table-column prop="" label="状态" width="100">
          <template scope="scope">
            <span v-show="scope.row.auditStatus == '1'" style="color:#0c46a2;">待审核</span>
            <span v-show="scope.row.auditStatus == '2'" style="color:green;">审核通过</span>
            <span v-show="scope.row.auditStatus == '3'" style="color:red;">审核驳回</span>
          </template>
        </el-table-column>
        <el-table-column prop="visitTime" :formatter="dateTimeFormat" label="预计到访时间" width="180"></el-table-column>
        <el-table-column prop="visitDepmetname" label="到访部门" width="160" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="" label="行驶证副本" width="100">
          <template scope="scope">
            <el-button type="text" size="mini" @click="chakan(scope.row)" v-if="scope.row.applyType == '2'">查看</el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="visitDesc" label="到访事由" width="180" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="createTime" :formatter="dateTimeFormat" label="预约时间" width="180"></el-table-column>
        <el-table-column prop="auditUserName" label="审核人" width="150" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="auditTime" :formatter="dateTimeFormat" label="审核时间" width="180"></el-table-column>
        <el-table-column prop="auditReason" label="驳回原因" width="180" :formatter="formatterRowEmpty"></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div>
      <el-pagination
        background
        @current-change="handleCurrentChangeA"
        :current-page="searchFrom.pageNo"
        :page-size="searchFrom.pageSize"
        :page-sizes="[25,50,100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChangeA"
        :total="total"
      ></el-pagination>
    </div>
    <!--点击驳回-->
    <el-dialog title="驳回" :close-on-click-modal="false" :close-on-press-escape="false"
    :visible.sync="rejectmark" ref="rejectFrom" width="550px" center>
      <span>
        <el-form :model="rejectFrom" :rules="rules" :validate-on-rule-change = "false"
          ref="rejectFrom" label-width="110px" v-if="rejectmark">
          <div class="addinpBox" >
            <el-form-item label="驳回原因:" prop="auditReaso" style="margin-top:10px;">
              <el-input type="textarea" v-model="rejectFrom.auditReaso" maxlength="100" onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="rejectmark = false" size='mini'>取 消</el-button>
        <el-button type="primary" size='mini' @click="rejectSubmit('rejectFrom')">确定</el-button>
      </span>
    </el-dialog>
    <!-- 查看营业执照 -->
    <el-dialog title="查看" :close-on-click-modal="false" :close-on-press-escape="false" @close="closeLook" :visible.sync="lookDialog" width="500px" center>
      <div style="width: 260px; height: 300px;margin:20px auto;">
        <el-form :inline="true" :model="lookFrom" ref="lookFrom" class="demo-form-inline" size="mini">
          <el-form-item v-if="lookDialog">
            <el-image :src="lookFrom.fileKeyUrl" style="width: 260px; height: 200px;"
              :preview-src-list="[lookFrom.fileKeyUrl]">
            </el-image>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lookDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat,formatterRowEmpty} from '@/utils/util'
import { visitauditList,visitauditListPass,visitauditBackaudit,visitauditDetail } from '@/api/vgs-driver'
export default {
  name: 'Freight',
  components: {
  },
  data () {
    return {
      formatterRowEmpty:formatterRowEmpty,
      dateTimeFormat: dateTimeFormat,
      loading: false,
      auditStatusList:[
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '待审核',
          value: '1'
        },
        {
          showName: '审核通过',
          value: '2'
        },
        {
          showName: '审核驳回',
          value: '3'
        }
      ],
      applyTypeList:[
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '人员登记',
          value: '1'
        },
        {
          showName: '人车登记',
          value: '2'
        }
      ],
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      // 查询条件
      createTimes:[],
      visitTimes:[],
      searchFrom: {
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      },
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['00BM0K0100','00BM0K0200'],
      tableList: [],
      passIds:[],
      rules: {
        auditReaso: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' }
        ]
      },
      rejectmark: false, // 驳回弹窗
      // 驳回
      rejectFrom: {
        id:'',
        auditStatus:'',
        auditReaso: '' // 驳回原因
      },
      lookDialog:false,
      lookFrom:{
        fileKeyUrl:''
      }
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/perAndVhcProcess')
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 98 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 获取列表
    getList () {
      this.loading = true
      this.searchFrom.startcreateTime = this.createTimes[0]
      this.searchFrom.endcreateTime = this.createTimes[1]
      this.searchFrom.startvisitTime = this.visitTimes[0]
      this.searchFrom.endvisitTime = this.visitTimes[1]
      visitauditList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongZhi () {
      this.searchFrom = {
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      }
      this.createTimes = []
      this.visitTimes = []
      this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 审核通过
    passFn(){
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      }else{
        let flagA = selectData.every(item => item.auditStatus == '1')
        if(!flagA){
          this.$alert('只能选择待审核的数据', '系统提示')
        }else{
          this.passIds = []
          selectData.forEach(element => {
            this.passIds.push(element.id)
          })
          this.$confirm('是否操作？', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            visitauditListPass({
              Ids:this.passIds
            }).then(res => {
              loading.close()
              this.$message({
                message: '审核通过',
                type: 'success'
              })
              this.getList()
            })
            .catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }).catch(() => { })
        }
      }
    },
    // 审核驳回
    backFn(){
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      }else if (selectData.length > 1) {
        this.$alert('请选择一条数据进行操作', '系统提示')
      }else{
        if(selectData[0].auditStatus != 1 ){
          this.$alert('只能选择待审核状态的数据', '系统提示')
          return
        }
        this.rejectFrom.auditReaso = ''
        this.rejectmark = true
        this.rejectFrom.id = selectData[0].id
      }
    },
    // 驳回确定
    rejectSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          visitauditBackaudit({
          // 驳回传3  通过传2
            auditReaso: this.rejectFrom.auditReaso,
            id: this.rejectFrom.id
          }).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.rejectmark = false
            this.getList()
          }).catch(err => {
            loading.close()
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    chakan(row){
      // 查看文件
      if(row.fileKeyUrl){
        this.lookFrom.fileKeyUrl = row.fileKeyUrl
        this.lookDialog = true
      }else{
        this.$message({
          message: '暂无文件照片',
          type: 'error'
        })
      }
    },
    closeLook(){
      this.lookDialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
.searchBtnBox {
   margin-left: 10px;
 }
/deep/.el-range-editor--mini.el-input__inner {
  height: 28px;
  width: 410px !important;
}
/deep/.el-form{
  width: 100%;
}
/deep/.searchBox .el-input--mini .el-input__inner{
  width: 150px !important;
}
</style>